import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import {addTranslations} from "../actions/TranslationActions";
import Translator from "../helpers/Translator";
import AirlinesFilterBlock from "./filters/AirlinesFilterBlock";
import FlightDurationBlock from "./filters/FlightDurationBlock";
import TimeBlock from "./filters/TimeBlock";
import StopsBlock from "./filters/StopsBlock";
import TransferTimeBlock from "./filters/TransferTimeBlock";
import ArrivalAirportBlock from "./filters/ArrivalAirportBlock";
import ReturnAirportBlock from "./filters/ReturnAirportBlock";
import ConnectionsBlock from "./filters/ConnectionsBlock";
import BaggageBlock from "./filters/BaggageBlock";
import IframeHelper from "../helpers/IframeHelper";
import {resetAllFilters} from "../actions/FlightsActions";
import {DOMAIN} from "./FilterContainer";
import Loader from "../helpers/Loader";

class Filters extends Component {
    componentDidMount() {
        let translations = {};
        translations[DOMAIN] = JSON.parse(this.props.dataTranslations);
        this.props.addTranslations(translations);
    }

    componentDidUpdate() {
        IframeHelper.updateHeight(this.props.parameters.projectUrl);
    }

    renderReturnTimeBlock(from, to, name) {
        if (!this.props.parameters['search-params'].returnDate) {
            return null;
        }

        return <TimeBlock type="return" from={from} to={to} filter="returnTime" name={name}/>;
    }

    resetAllFilters() {
        this.props.resetAllFilters();
    }

    hasSelectedFilters() {
        let hasApplied = false;

        Object.keys(this.props.appliedFilters.groups).map((filter) => {
            if (this.props.appliedFilters.groups[filter].enabled) {
                hasApplied = true;
            }

            return true;
        });

        return hasApplied;
    }

    renderResetAllButton() {
        if (this.hasSelectedFilters()) {
            return <button onClick={this.props.resetAllFilters.bind(this)} className="btn btn-outline-primary btn-sm float-right">{this.translator.trans('Reset all')}</button>;
        }

        return null;
    }

    appliedFiltersCount() {
        let count = 0;
        Object.keys(this.props.appliedFilters.groups).map((filterKey) => {
            if (this.props.appliedFilters.groups[filterKey]['enabled'] === true ||
                this.props.appliedFilters.groups[filterKey]['enabled'] === 1 ) {
                count++;
            }
        });

        return count;
    }

    removeDuplicateReturnButton() {
        document.querySelectorAll('.js-filter-close')[1].style.display = 'none';
    }

    render() {
        if (Loader.showLoader(this.props.flights) || (this.props.flights.flights.length === 0 && this.appliedFiltersCount() === 0)) {
            this.removeDuplicateReturnButton();
            return null;
        }

        this.translator = new Translator(this.props.translations.translations, DOMAIN);
        const route = JSON.parse(this.props.parameters.route);

        return (
            <div className="card filters">
                <div className="card-header">
                    {this.translator.trans('Filter results')}
                    {this.renderResetAllButton()}
                </div>
                <AirlinesFilterBlock carriers={this.props.carriers}/>
                <FlightDurationBlock/>
                <TimeBlock type="forward" from={route.from.general} to={route.to.general} filter="forwardTime" name={`${this.translator.trans('Time')} (${route.from.general}-${route.to.general})`}/>
                {this.renderReturnTimeBlock(route.to.general, route.from.general, `${this.translator.trans('Time')} (${route.to.general}-${route.from.general})`)}
                <StopsBlock/>
                <TransferTimeBlock/>
                <ArrivalAirportBlock/>
                <ReturnAirportBlock/>
                <ConnectionsBlock/>
                <BaggageBlock/>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({addTranslations, resetAllFilters}, dispatch);
}

function mapStateToProps(state, ownProps) {
    return {
        dataTranslations: ownProps.translations,
        translations: state.TranslationsReducer,
        carriers: state.AirlinesFilterReducer.carriers,
        flights: state.FlightsReducer,
        parameters: state.ParametersReducer.parameters,
        appliedFilters: state.FilterGroupsReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Filters);



// WEBPACK FOOTER //
// ./src/components/Filters.js